<template>
  <div class="columns">
    <div class="column is-one-fifth container">
      <div class="search-links">
        <hr />
        <ul>
          <li><router-link :to="{ name: 'gci' }">Search GCI</router-link></li>
          <li>
            <router-link :to="{ name: 'gcibrowse' }" class="active"
              >Browse GCI</router-link
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="column is-four-fifth container filters">
      <div class="browse-title">
        <h2>Browse GCI</h2>
      </div>
      <div class="columns">
        <div class="column">
          <div class="filter-title">
            <h2>Type of Information</h2>
          </div>
          <ul>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'des' } }"
                >Project Descriptions (Including Videos) (625)</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'pub' } }"
                >Publications (PDFs, Books) (252)</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'fdl' } }"
                >Free PDFs Download (127)</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'tch' } }"
                >Teaching Resources (59)</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'pol' } }"
                >Cultural Heritage Policy Documents (80)</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'nws' } }"
                >Newsletters (1189)</router-link
              >
            </li>
            <li>
              <router-link
                :to="{ path: 'browseresults', query: { ca: 'n', d: 'cnf' } }"
                >Lectures &amp; Conferences (63)</router-link
              >
            </li>
          </ul>
        </div>
        <div class="column is-half core-areas">
          <div class="filter-title">
            <h2>Core Areas of Work</h2>
          </div>
          <div class="columns">
            <div class="column">
              <strong>Built Heritage</strong>
              <b-collapse :open="false" aria-id="projectDescriptions">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="projectDescriptions"
                  v-on:click="archShow = !archShow"
                >
                  <b-icon
                    v-bind:class="{ active: archShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span>Archaeological Site Conservation &amp; Management</span>
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arh,des' }
                      }"
                      >Project Descriptions (901)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arh,pub' }
                      }"
                      >Publications (643)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arh,tch' }
                      }"
                      >Teaching Resources (508)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arh,nws' }
                      }"
                      >Newsletters (1617)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arh,cnf' }
                      }"
                      >Lectures &amp; Conferences (543)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
              <b-collapse :open="false" aria-id="buildingMats">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="buildingMats"
                  v-on:click="buildShow = !buildShow"
                >
                  <b-icon
                    v-bind:class="{ active: buildShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span
                    >Building Materials (Earth, Stone, Renders, and
                    Mortars)</span
                  >
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'bld,des' }
                      }"
                      >Project Descriptions (790)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'bld,pub' }
                      }"
                      >Publications (535)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'bld,tch' }
                      }"
                      >Teaching Resources (339)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'bld,nws' }
                      }"
                      >Newsletters (1474)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'bld,cnf' }
                      }"
                      >Lectures &amp; Conferences (389)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
              <b-collapse :open="false" aria-id="conservationMethods">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="conservationMethods"
                  v-on:click="consShow = !consShow"
                >
                  <b-icon
                    v-bind:class="{ active: consShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span>Conservation Principles &amp; Methods</span>
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'pri,des' }
                      }"
                      >Project Descriptions (989)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'pri,pub' }
                      }"
                      >Publications (816)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'pri,tch' }
                      }"
                      >Teaching Resources (707)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'pri,nws' }
                      }"
                      >Newsletters (1762)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'pri,cnf' }
                      }"
                      >Lectures &amp; Conferences (726)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
              <b-collapse :open="false" aria-id="decoratedSurfaces">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="decoratedSurfaces"
                  v-on:click="decSurfShow = !decSurfShow"
                >
                  <b-icon
                    v-bind:class="{ active: decSurfShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span
                    >Decorated Surfaces (Mosaics, Wall Paintings, Rock
                    Art)</span
                  >
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arr,des' }
                      }"
                      >Project Descriptions (878)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arr,pub' }
                      }"
                      >Publications (634)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arr,tch' }
                      }"
                      >Teaching Resources (472)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arr,nws' }
                      }"
                      >Newsletters (1567)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'arr,cnf' }
                      }"
                      >Lectures &amp; Conferences (506)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
              <b-collapse :open="false" aria-id="historicBuildings">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="historicBuildings"
                  v-on:click="histShow = !histShow"
                >
                  <b-icon
                    v-bind:class="{ active: histShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span>Historic Buildings Cities &amp; Urban Settlements</span>
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'hst,des' }
                      }"
                      >Project Descriptions (882)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'hst,pub' }
                      }"
                      >Publications (585)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'hst,tch' }
                      }"
                      >Teaching Resources (433)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'hst,nws' }
                      }"
                      >Newsletters (1531)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'hst,cnf' }
                      }"
                      >Lectures &amp; Conferences (464)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
              <b-collapse :open="false" aria-id="decoratedSurfaces">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="decoratedSurfaces"
                  v-on:click="modShow = !modShow"
                >
                  <b-icon
                    v-bind:class="{ active: modShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span>Modern Architectures</span>
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'moa,des' }
                      }"
                      >Project Descriptions (690)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'moa,pub' }
                      }"
                      >Publications (340)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'moa,nws' }
                      }"
                      >Newsletters (1253)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'moa,cnf' }
                      }"
                      >Lectures &amp; Conferences (152)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
              <b-collapse :open="false" aria-id="historicBuildings">
                <button
                  class="button is-filter"
                  slot="trigger"
                  aria-controls="historicBuildings"
                  v-on:click="recShow = !recShow"
                >
                  <b-icon
                    v-bind:class="{ active: recShow }"
                    icon="menu-right"
                  ></b-icon>
                  <span>Recording &amp; Documentation</span>
                </button>
                <ul>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'rec,des' }
                      }"
                      >Project Descriptions (676)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'rec,pub' }
                      }"
                      >Publications (418)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'rec,nws' }
                      }"
                      >Newsletters (1359)</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{
                        path: 'browseresults',
                        query: { ca: 'n', d: 'rec,cnf' }
                      }"
                      >Lectures &amp; Conferences (252)</router-link
                    >
                  </li>
                </ul>
              </b-collapse>
            </div>
            <div class="column">
              <div>
                <strong>Objects &amp; Collections</strong>
                <b-collapse :open="false" aria-id="artistsMats">
                  <button
                    class="button is-filter"
                    slot="trigger"
                    aria-controls="artistsMats"
                    v-on:click="artShow = !artShow"
                  >
                    <b-icon
                      v-bind:class="{ active: artShow }"
                      icon="menu-right"
                    ></b-icon>
                    <span>Artists' Materials &amp; Collection Research</span>
                  </button>
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mtl,des' }
                        }"
                        >Project Descriptions (894)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mtl,pub' }
                        }"
                        >Publications (648)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mtl,tch' }
                        }"
                        >Teaching Resources (527)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mtl,nws' }
                        }"
                        >Newsletters (1506)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mtl,cnf' }
                        }"
                        >Lectures &amp; Conferences (513)</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
                <b-collapse :open="false" aria-id="devAnalytical">
                  <button
                    class="button is-filter"
                    slot="trigger"
                    aria-controls="devAnalytical"
                    v-on:click="devShow = !devShow"
                  >
                    <b-icon
                      v-bind:class="{ active: devShow }"
                      icon="menu-right"
                    ></b-icon>
                    <span>Development of Analytical Methodologies</span>
                  </button>
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ana,des' }
                        }"
                        >Project Descriptions (725)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ana,pub' }
                        }"
                        >Publications (533)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ana,nws' }
                        }"
                        >Newsletters (1419)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ana,cnf' }
                        }"
                        >Lectures &amp; Conferences (351)</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
                <b-collapse :open="false" aria-id="modCont">
                  <button
                    class="button is-filter"
                    slot="trigger"
                    aria-controls="modCont"
                    v-on:click="modContShow = !modContShow"
                  >
                    <b-icon
                      v-bind:class="{ active: modContShow }"
                      icon="menu-right"
                    ></b-icon>
                    <span>Modern &amp; Contemporary Art</span>
                  </button>
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mod,des' }
                        }"
                        >Project Descriptions (788)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mod,pub' }
                        }"
                        >Publications (466)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mod,nws' }
                        }"
                        >Newsletters (1320)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'mod,cnf' }
                        }"
                        >Lectures &amp; Conferences (291)</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
                <b-collapse :open="false" aria-id="photographs">
                  <button
                    class="button is-filter"
                    slot="trigger"
                    aria-controls="photographs"
                    v-on:click="photoShow = !photoShow"
                  >
                    <b-icon
                      v-bind:class="{ active: photoShow }"
                      icon="menu-right"
                    ></b-icon>
                    <span>Photographs</span>
                  </button>
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pho,des' }
                        }"
                        >Project Descriptions (674)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pho,pub' }
                        }"
                        >Publications (311)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pho,tch' }
                        }"
                        >Teaching Resources (122)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pho,nws' }
                        }"
                        >Newsletters (1226)</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
                <b-collapse :open="false" aria-id="preventativeConservation">
                  <button
                    class="button is-filter"
                    slot="trigger"
                    aria-controls="preventativeConservation"
                    v-on:click="prevenShow = !prevenShow"
                  >
                    <b-icon
                      v-bind:class="{ active: prevenShow }"
                      icon="menu-right"
                    ></b-icon>
                    <span>Preventive Conservation</span>
                  </button>
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pre,des' }
                        }"
                        >Project Descriptions (737)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pre,pub' }
                        }"
                        >Publications (470)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pre,tch' }
                        }"
                        >Teaching Resources (308)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pre,nws' }
                        }"
                        >Newsletters (1384)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'pre,cnf' }
                        }"
                        >Lectures &amp; Conferences (301)</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
              </div>
              <div>
                <strong>Education &amp; Dissemination</strong>
                <b-collapse :open="false" aria-id="conservationEd">
                  <button
                    class="button is-filter"
                    slot="trigger"
                    aria-controls="conservationEd"
                    v-on:click="consEdShow = !consEdShow"
                  >
                    <b-icon
                      v-bind:class="{ active: consEdShow }"
                      icon="menu-right"
                    ></b-icon>
                    <span>Conservation Education</span>
                  </button>
                  <ul>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ped,des' }
                        }"
                        >Project Descriptions (747)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ped,pub' }
                        }"
                        >Publications (557)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ped,nws' }
                        }"
                        >Newsletters (1492)</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: 'browseresults',
                          query: { ca: 'n', d: 'ped,cnf' }
                        }"
                        >Lectures &amp; Conferences (392)</router-link
                      >
                    </li>
                  </ul>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="filter-title">
            <h2>Geographic Region</h2>
          </div>
          <b-collapse :open="false" aria-id="subAfrica">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="subAfrica"
              v-on:click="subSaharanShow = !subSaharanShow"
            >
              <b-icon
                v-bind:class="{ active: subSaharanShow }"
                icon="menu-right"
              ></b-icon>
              <span>Sub-Saharan Africa</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ssa,des' }
                  }"
                  >Project Descriptions (663)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ssa,pub' }
                  }"
                  >Publications (414)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ssa,nws' }
                  }"
                  >Newsletters (1373)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ssa,cnf' }
                  }"
                  >Lectures &amp; Conferences (248)</router-link
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="midEastAfrica">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="midEastAfrica"
              v-on:click="midEastShow = !midEastShow"
            >
              <b-icon
                v-bind:class="{ active: midEastShow }"
                icon="menu-right"
              ></b-icon>
              <span>Middle East &amp; North Africa</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ame,des' }
                  }"
                  >Project Descriptions (703)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ame,pub' }
                  }"
                  >Publications (535)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ame,nws' }
                  }"
                  >Newsletters (1464)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'ame,cnf' }
                  }"
                  >Lectures &amp; Conferences (365)</router-link
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="europe">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="europe"
              v-on:click="euroShow = !euroShow"
            >
              <b-icon
                v-bind:class="{ active: euroShow }"
                icon="menu-right"
              ></b-icon>
              <span>Europe</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'eur,des' }
                  }"
                  >Project Descriptions (763)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'eur,pub' }
                  }"
                  >Publications (683)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'eur,tch' }
                  }"
                  >Teaching Resources (464)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'eur,nws' }
                  }"
                  >Newsletters (1614)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'eur,cnf' }
                  }"
                  >Lectures &amp; Conferences (512)</router-link
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="asia">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="asia"
              v-on:click="asiaShow = !asiaShow"
            >
              <b-icon
                v-bind:class="{ active: asiaShow }"
                icon="menu-right"
              ></b-icon>
              <span>Asia</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'asi,des' }
                  }"
                  >Project Descriptions (709)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'asi,pub' }
                  }"
                  >Publications (509)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'asi,tch' }
                  }"
                  >Teaching Resources (351)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'asi,nws' }
                  }"
                  >Newsletters (1460)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'asi,cnf' }
                  }"
                  >Lectures &amp; Conferences (336)</router-link
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="northAmerica">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="northAmerica"
              v-on:click="naShow = !naShow"
            >
              <b-icon
                v-bind:class="{ active: naShow }"
                icon="menu-right"
              ></b-icon>
              <span>North America</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'naa,des' }
                  }"
                  >Project Descriptions (742)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'naa,pub' }
                  }"
                  >Publications (594)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'naa,nws' }
                  }"
                  >Newsletters (1527)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'naa,cnf' }
                  }"
                  >Lectures &amp; Conferences (417)</router-link
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="southAmerica">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="southAmerica"
              v-on:click="saShow = !saShow"
            >
              <b-icon
                v-bind:class="{ active: saShow }"
                icon="menu-right"
              ></b-icon>
              <span>South America</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'saa,des' }
                  }"
                  >Project Descriptions (695)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'saa,pub' }
                  }"
                  >Publications (469)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'saa,tch' }
                  }"
                  >Teaching Resources (293)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'saa,nws' }
                  }"
                  >Newsletters (1384)</router-link
                >)
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'saa,cnf' }
                  }"
                  >Lectures &amp; Conferences (288)</router-link
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="oceania">
            <button
              class="button is-filter"
              slot="trigger"
              aria-controls="oceania"
              v-on:click="oceaShow = !oceaShow"
            >
              <b-icon
                v-bind:class="{ active: oceaShow }"
                icon="menu-right"
              ></b-icon>
              <span>Oceania</span>
            </button>
            <ul>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'oca,des' }
                  }"
                  >Project Descriptions (653)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'oca,pub' }
                  }"
                  >Publications (423)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'oca,nws' }
                  }"
                  >Newsletters (1369)</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    path: 'browseresults',
                    query: { ca: 'n', d: 'oca,cnf' }
                  }"
                  >Lectures &amp; Conferences (241)</router-link
                >
              </li>
            </ul>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrowseGCI",
  data() {
    return {
      searchedFilter: false,
      searchFilter: false,
      archShow: false,
      buildShow: false,
      consShow: false,
      decSurfShow: false,
      histShow: false,
      modShow: false,
      recShow: false,
      artShow: false,
      devShow: false,
      modContShow: false,
      photoShow: false,
      prevenShow: false,
      consEdShow: false,
      subSaharanShow: false,
      midEastShow: false,
      euroShow: false,
      asiaShow: false,
      naShow: false,
      saShow: false,
      oceaShow: false,
      clickedLink: false,
      query: "",
      filterBy: "",
      filter: "",
      filterDescription: "",
      searchText: "",
      inputUrl: "",
      searchTotals: "",
      searchResults: [],
      fromValue: 0,
      sizeValue: 50,
      startResults: 1,
      endResults: 50,
      currentPage: 1,
      endPage: 1,
      totalPages: 1,
      imageSearch: "",
      selectOptions: [
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.filters {
  .browse-title {
    font-size: 19px;
    background: $lighter-gray;
    padding: 10px 0;
    margin-bottom: 3px;
    h2 {
      text-align: center;
    }
  }
  .columns {
    margin: 0;
    .column {
      font-size: $size-7;
      padding: 0 0 0.75rem 0;
      &:not(.filter-title) {
        * {
          padding: 0.25em 0;
          text-align: left;
        }
        ul {
          list-style: square;
          padding-left: 1.5em;
        }
        &:last-child {
          .collapse {
            padding: 0.25em;
          }
        }
      }
      .filter-title {
        h2 {
          background-color: #cad5e9;
          text-align: center;
          height: 54px;
          line-height: 22.8px;
          padding: 5px 10px;
          font-size: 19px;
        }
      }
      &.core-areas {
        border-left: 1px solid $lighter-gray;
        border-right: 1px solid $lighter-gray;
        h2 {
          padding: 15px 10px;
        }
        .columns {
          .column {
            padding: 0.25em;
          }
        }
      }
      .collapse {
        .collapse-content {
          ul {
            padding-left: 2.5em;
          }
        }
      }
    }
  }
  .is-filter {
    white-space: normal;
    padding: 0;
    font-family: inherit;
    font-weight: normal;
    font-size: 1em;
    line-height: 1;
    border: none;
    color: $blue;
    &:focus {
      border: none;
      box-shadow: none;
    }
    &:hover {
      text-decoration: underline;
    }
    .icon {
      transition: ease-in-out;
    }
    .icon.active {
      transform: rotate(90deg);
    }
  }
}
</style>
